(function() {
    var module;

    try {
        // Get current templates module
        module = angular.module('templates');
    } catch (error) {
        // Or create a new one
        module = angular.module('templates', []);
    }

    module.run(["$templateCache", function($templateCache) {
        $templateCache.put('module/slides/intro.html', '<div class=\"slide slide--{{slide.type}}\">\n	<div class=\"slide_inner\">\n		<div class=\"v-align\">\n			<div class=\"slide_content\">\n				<div class=\"text-cnt\">\n					<h3 ng-if=\"slide.title\" class=\"slide_title question\">{{ slide.title }}</h3>\n					<div ng-if=\"slide.content\" ng-bind-html=\"slide.content\"></div>\n				</div>\n			</div>\n		</div>\n	</div>\n</div>\n');
    }]);
})();